import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import Card from "@mui/material/Card";
import {
    Box,
    Button,
    Divider,
    Stack,
    TextField,
    Grid,
    Typography,
    Switch,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import ToastApp from "../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import Autocomplete from "@mui/material/Autocomplete";
import { getISTDate } from "../../utils/Constant";
import CustomLabel from "../../CustomLable";
import ButtonWithLoader from "../../utils/ButtonWithLoader";
import CustomDataGrid from "../../utils/CustomDatagrid";
import Languages from "../../Languages";
import { Language, ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../TranslateTextField";
import DataGrids from "../../utils/Datagrids";
import { faBullseye } from "@fortawesome/free-solid-svg-icons";
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Collapse, IconButton,
} from '@mui/material';
import { ExpandMore, ExpandLess, ArrowUpward, ArrowDownward } from '@mui/icons-material';
import lightOn from "../../assets/images/Light_On.png";
import lightOff from "../../assets/images/Light_Off.png";



interface MenuPermission {
    isAdd: boolean;
    isEdit: boolean;
    isPrint: boolean;
    isDel: boolean;
}

export default function Lightswitchonoff() {
    const { t } = useTranslation();
    const { defaultValuestime } = getISTDate();
    const [zones, setZones] = useState<any>([]);
    const [columns, setColumns] = useState<any>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isShow, setIsShow] = useState(false);
    const location = useLocation();
    const [editId, setEditId] = useState(0);
    //   const [option, setOption] = useState([
    //     { value: "-1", label: t("text.SelectCountryName") },
    //   ]);
    const [permissionData, setPermissionData] = useState<MenuPermission>({
        isAdd: false,
        isEdit: false,
        isPrint: false,
        isDel: false,
    });
    const [lang, setLang] = useState<Language>("en");
    let navigate = useNavigate();

    const [Option, setOption] = useState([
        { value: "-1", label: t("text.SelectZone") },
    ]);

    const [taxOption, setTaxOption] = useState([
        { value: "-1", label: t("text.SelectWard") },
    ]);
    const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set());

    const [isData, setData] = useState<any>([]);

    const [Option1, setOption1] = useState([
        { value: "-1", label: t("text.SelectPole") },
    ]);




    useEffect(() => {

        getSupliar();

    }, [isLoading]);

    const getTableData = async (Id: any) => {
        const collectData = {
            "lightInstId": Id,
            "zoneId": formik.values.zoneId || -1,
            "wordId": formik.values.wordId || -1,
            "show": true,
            "exportOption": ""
        };
        const response = await api.post(`LightInstallation/GetLightInstallation`, collectData);
        const data = response.data.data;

        setData(data);
    };


    const getPole = async (wardID: any) => {
        const collectData = {
            "poleInstId": -1,
            "zoneId": -1,
            "wardId": wardID
        };
        const res = await api.post(`PoleInstallation/GetPoleNoZoneWardWise`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.poleno,
                value: item.poleInstId,
            })) || [];

        setOption1(arr);
    };




    const [sortConfig, setSortConfig] = useState({ key: 'serialNo', direction: 'asc' });  // Default sorting by 'serialNo'

    const handleSort = (columnKey: any) => {
        let direction = 'asc';
        if (sortConfig.key === columnKey && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key: columnKey, direction });
    };

    const sortedZones = [...zones].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
    });





    const handleSwitchChange = (
        event: React.ChangeEvent<HTMLInputElement>,
        child: any,
        lightInstId: number
    ) => {
        const updatedStatus = event.target.checked ? true : false;


        const updatedChildren = zones.map((zone: any) => {
            if (zone.lightInstId === lightInstId) {
                const updatedLightInstalChild = zone.children.map((item: any) => {
                    if (item.lightInstallationId === child.lightInstallationId) {
                        return { ...item, isOn: updatedStatus };
                    }
                    return item;
                });
                return { ...zone, children: updatedLightInstalChild };
            }
            return zone;
        });




        const collectData = {
            "lightInstId": isData[0]?.lightInstId || 0,
            "zoneId": isData[0]?.zoneId || 0,
            "wordId": isData[0]?.wordId || 0,
            "poleNo": isData[0]?.poleNo || "",
            "instDate": isData[0]?.instDate || "",
            "instBy": isData[0]?.instBy || 0,
            "apprBy": isData[0]?.apprBy || 0,
            "apprImg": isData[0]?.apprImg || "",
            "apprDate": isData[0]?.apprDate || "",
            "zoneName": isData[0]?.zoneName || "",
            "wardName": isData[0]?.wardName || "",
            "img": isData[0]?.img || "",
            "lightInstalChild": updatedChildren.find((z: any) => z.lightInstId === lightInstId)?.children || []

        };


        api.post(`LightInstallation/AddUpdateLightInstallation`, collectData)
            .then((response) => {
                if (response.data.isSuccess) {
                    toast.success(response.data.mesg);
                    fetchZonesData(); // Refresh the data after the update
                } else {
                    toast.error(response.data.mesg);
                }
            });
    };

    // const handleParentSwitchChange = (
    //     event: React.ChangeEvent<HTMLInputElement>,

    // ) => {
    //     // console.log(value)
    //     const updatedStatus = event.target.checked ? true : false;
    //     const collectData = {
    //         "lightInstId": isData[0]?.lightInstId || 0,
    //         "zoneId": isData[0]?.zoneId || 0,
    //         "wordId": isData[0]?.wordId || 0,
    //         "poleNo": isData[0]?.poleNo || "",
    //         "instDate": isData[0]?.instDate || "",
    //         "instBy": isData[0]?.instBy || 0,
    //         "apprBy": isData[0]?.apprBy || 0,
    //         "apprImg": isData[0]?.apprImg || "",
    //         "apprDate": isData[0]?.apprDate || "",
    //         "zoneName": isData[0]?.zoneName || "",
    //         "wardName": isData[0]?.wardName || "",
    //         "img": isData[0]?.img || "",
    //         "lightInstalChild": isData[0]?.lightInstalChild.map((item: any) => ({
    //             ...item,
    //             isOn: updatedStatus

    //         })) || []
    //     };
    //     api
    //         .post(`LightInstallation/AddUpdateLightInstallation`, collectData)
    //         .then((response) => {
    //             if (response.data.isSuccess) {
    //                 toast.success(response.data.mesg);
    //                 fetchZonesData();
    //             } else {
    //                 toast.error(response.data.mesg);
    //             }
    //         });
    // };

    const getSupliar = async () => {
        const collectData = {
            zoneID: -1,
            user_ID: "",
        };
        const res = await api.post(`Zone/GetZonemaster`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.zoneName,
                value: item.zoneID,
            })) || [];

        setOption(arr);
    };

    const getTaxData = async (Id: any) => {
        const collectData = {
            areaID: -1,
            zoneID: Id
        };
        const res = await api.post(`AreaWardMaster/GetAreaWardMaster`, collectData);
        const arr =
            res?.data?.data?.map((item: any) => ({
                label: item.areaName,
                value: item.areaID,
            })) || [];

        setTaxOption(arr);
    };
    //   const getCountryName = () => {
    //     const collectData = {
    //       countryId: -1,
    //     };
    //     api.post(`Country/GetCountryMaster`, collectData).then((res) => {
    //       const arr = [];
    //       //console.log("result" + JSON.stringify(res.data.data));
    //       for (let index = 0; index < res.data.data.length; index++) {
    //         arr.push({
    //           label: res.data.data[index]["countryName"],
    //           value: res.data.data[index]["countryId"],
    //         });
    //       }
    //       setOption(arr);
    //     });
    //   };

    // const validationSchema = Yup.object({

    //     brandName: Yup.string().test(
    //         "required",
    //         t("text.brandName"),
    //         function (value: any) {
    //             return value && value.trim() !== "";
    //         }
    //     ),
    // });

    const formik = useFormik({
        initialValues: {
            "lightInstId": 0,
            "zoneId": 0,
            "wordId": 0,
            "poleNo": "",
            fromDate: null,
            toDate: null


        },
        // validationSchema: validationSchema,
        onSubmit: async (values) => {

        },
    });

    const requiredFields = ["itemType"];

    const routeChangeEdit = (row: any) => {
        formik.setFieldValue("brandName", row.brandName);
        formik.setFieldValue("brandAbbrevation", row.brandAbbrevation);
        formik.setFieldValue("brandID", row.brandID);

        setEditId(row.id);
    };




    const fetchZonesData = async () => {
        try {
            const collectData = {
                "lightInstId": -1,
                "zoneId": formik.values.zoneId || -1,
                "wordId": formik.values.wordId || -1,
                "poleNo": formik.values.poleNo || "",
                "fromDate": formik.values.fromDate,
                "toDate": formik.values.toDate
            };
            const response = await api.post(`/LightInstallation/GetLightSwitchOnOf`, collectData);
            const data = response.data.data;
            const zonesWithIds = data.map((zone: any, index: any) => ({
                ...zone,
                serialNo: index + 1,
                id: zone.lightInstId,
                children: zone.lightInstalChild || []
            }));
            setZones(zonesWithIds);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    // Handle Row Click (expand/collapse)
    const handleRowClick = (lightInstId: number) => {
        setExpandedRows(prevState => {
            const newState = new Set(prevState);
            if (newState.has(lightInstId)) {
                newState.delete(lightInstId); // Collapse if already expanded
            } else {
                newState.add(lightInstId); // Expand if not
            }
            return newState;
        });
    };




    return (
        <>
            <Card
                style={{
                    width: "100%",
                    backgroundColor: "#E9FDEE",
                    border: ".5px solid #2B4593 ",
                    marginTop: "3vh",
                }}
            >
                <Paper
                    sx={{
                        width: "100%",
                        overflow: "hidden",
                    }}
                    style={{ padding: "10px" }}
                >
                    <ConfirmDialog />

                    <Grid item xs={12} container spacing={2}>
                        <Grid item lg={10} md={10} xs={12}>
                            <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                sx={{ padding: "20px" }}
                                align="left"
                            >
                                {t("text.lightswitch")}
                            </Typography>
                        </Grid>

                        <Grid item lg={2} md={2} xs={12} marginTop={2}>
                            <select
                                className="language-dropdown"
                                value={lang}
                                onChange={(e) => setLang(e.target.value as Language)}
                            >
                                {Languages.map((l) => (
                                    <option key={l.value} value={l.value}>
                                        {l.label}
                                    </option>
                                ))}
                            </select>
                        </Grid>
                    </Grid>

                    <Divider />

                    <Box height={10} />

                    <Stack direction="row" spacing={2} classes="my-2 mb-2"></Stack>

                    <form onSubmit={formik.handleSubmit}>
                        <Grid item xs={12} container spacing={3}>



                            <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={Option}
                                    //   value={
                                    //     Option.find(
                                    //       (option: any) => option.value === formik.values.stateId
                                    //     ) || null
                                    //   }
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        console.log(newValue?.value);

                                        formik.setFieldValue("zoneId", newValue?.value);
                                        // formik.setFieldValue("zoneName", newValue?.label);
                                        getTaxData(newValue?.value)
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={
                                                <CustomLabel
                                                    text={t("text.SelectZone")}
                                                    required={false}
                                                />
                                            }
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={taxOption}
                                    //   value={
                                    //     Option.find(
                                    //       (option: any) => option.value === formik.values.stateId
                                    //     ) || null
                                    //   }
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        console.log(newValue?.value);

                                        formik.setFieldValue("wordId", newValue?.value);
                                        //formik.setFieldValue("wardName", newValue?.label);
                                        getPole(newValue?.value);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={
                                                <CustomLabel
                                                    text={t("text.SelectWard")}
                                                    required={false}
                                                />
                                            }
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item sm={4} lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={Option1}
                                    //   value={
                                    //     Option.find(
                                    //       (option: any) => option.value === formik.values.stateId
                                    //     ) || null
                                    //   }
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        //console.log(newValue?.value);

                                        //formik.setFieldValue("wordId", newValue?.value);
                                        formik.setFieldValue("poleNo", newValue?.label);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={
                                                <CustomLabel
                                                    text={t("text.SelectPole")}
                                                    required={false}
                                                />
                                            }
                                        />
                                    )}
                                />
                            </Grid>



                            <Grid item sm={4} lg={4} xs={12}>
                                <TextField
                                    label={<CustomLabel text={t("text.FromDate")} />}
                                    value={formik.values.fromDate}
                                    name="fromDate"
                                    id="fromDate"
                                    placeholder={t("text.FromDate")}
                                    size="small"
                                    fullWidth
                                    type="date"
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item sm={4} lg={4} xs={12}>
                                <TextField
                                    label={<CustomLabel text={t("text.ToDate")} />}
                                    value={formik.values.toDate}
                                    name="toDate"
                                    id="toDate"
                                    placeholder={t("text.ToDate")}
                                    type="date"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>

                            <Grid item xs={12} lg={4}>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth={true}
                                    style={{
                                        // width: "60%",

                                        backgroundColor: `var(--header-background)`,
                                        //margin: "1%",
                                    }}
                                    onClick={() => {
                                        fetchZonesData();
                                        setIsShow(true);
                                    }}
                                >
                                    {t("text.show")}
                                </Button>


                            </Grid>
                        </Grid>




                        <Grid item xs={12} container spacing={2} sx={{ marginTop: "2%" }}>
                            <Grid item lg={12} md={12} xs={12}>
                                {isShow && (



                                    <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2, marginTop: 2 }}>
                                        <Table sx={{ minWidth: 650 }} aria-label="light installation table">
                                            <TableHead>
                                                <TableRow>
                                                    {['serialNo', 'zoneName', 'wardName', 'poleNo'].map((column) => (
                                                        <TableCell
                                                            key={column}
                                                            align="center"
                                                            sx={{
                                                                fontWeight: 'bold',
                                                                backgroundColor: `var(--grid-headerBackground)`,
                                                                color: `var(--grid-headerColor)`,
                                                                cursor: 'pointer',
                                                            }}
                                                            onClick={() => handleSort(column)}
                                                        >
                                                            {column.charAt(0).toUpperCase() + column.slice(1)} {/* Capitalize column name */}
                                                            <IconButton sx={{ padding: 0 }}>
                                                                {sortConfig.key === column && sortConfig.direction === 'asc' ? (
                                                                    <ArrowUpward sx={{ fontSize: 18, color: 'white' }} />
                                                                ) : sortConfig.key === column && sortConfig.direction === 'desc' ? (
                                                                    <ArrowDownward sx={{ fontSize: 18, color: 'white' }} />
                                                                ) : null}
                                                            </IconButton>
                                                        </TableCell>
                                                    ))}
                                                    <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: `var(--grid-headerBackground)`, color: `var(--grid-headerColor)` }}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {sortedZones.map((zone) => (
                                                    <React.Fragment key={zone.lightInstId}>
                                                        {/* Parent Row */}
                                                        <TableRow
                                                            hover
                                                            onClick={() => {
                                                                handleRowClick(zone.lightInstId);
                                                                getTableData(zone.lightInstId);

                                                                // Add other functionality here as needed
                                                            }}
                                                            sx={{
                                                                cursor: 'pointer',
                                                                backgroundColor: expandedRows.has(zone.lightInstId) ? '#f1f1f1' : 'white',
                                                                '&:hover': {
                                                                    backgroundColor: '#e0f7fa',
                                                                },
                                                            }}
                                                        >
                                                            <TableCell align="center" style={{ padding: '3px 16px' }}>{zone.serialNo}</TableCell>
                                                            <TableCell align="center" style={{ padding: '3px 16px' }}>{zone.zoneName}</TableCell>
                                                            <TableCell align="center" style={{ padding: '3px 16px' }}>{zone.wardName ? `${zone.wardName} (${zone.wardNo})` : "_ _"}</TableCell>
                                                            <TableCell align="center" style={{ padding: '3px 16px' }}>{zone.poleNo}</TableCell>
                                                            <TableCell align="center" style={{ padding: '3px 16px' }}>
                                                                <IconButton
                                                                    onClick={() => handleRowClick(zone.lightInstId)}
                                                                    sx={{ color: '#42b6f5' }}
                                                                >
                                                                    {expandedRows.has(zone.lightInstId) ? <ExpandLess /> : <ExpandMore />}
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>

                                                        {/* Child Rows (expandable) */}
                                                        <TableRow>
                                                            <TableCell colSpan={5} sx={{ padding: 0 }}>
                                                                <Collapse in={expandedRows.has(zone.lightInstId)} timeout="auto" unmountOnExit>
                                                                    <Box sx={{ margin: 2 }}>
                                                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#42b6f5' }}>
                                                                            Items Details:
                                                                        </Typography>
                                                                        <Table sx={{ marginTop: 1 }}>
                                                                            <TableHead>
                                                                                <TableRow>
                                                                                    <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: '#3351b5', color: 'white', padding: '3px 16px' }}>
                                                                                        Switch
                                                                                    </TableCell>
                                                                                    <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: '#3351b5', color: 'white', padding: '3px 16px' }}>
                                                                                        Item Name
                                                                                    </TableCell>
                                                                                    <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: '#3351b5', color: 'white', padding: '3px 16px' }}>
                                                                                        Light No
                                                                                    </TableCell>
                                                                                    <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: '#3351b5', color: 'white', padding: '3px 16px' }}>
                                                                                        Watt
                                                                                    </TableCell>
                                                                                    <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: '#3351b5', color: 'white', padding: '3px 16px' }}>
                                                                                        On/Off
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {zone.children.map((child: any, childIndex: any) => (
                                                                                    <TableRow key={`child-${childIndex}`} sx={{ backgroundColor: '#f9f9f9' }}>
                                                                                        <TableCell align="center" style={{ padding: '4px 16px' }}>
                                                                                            <Switch
                                                                                                checked={child.isOn === true}
                                                                                                style={{
                                                                                                    color: child.isOn === true ? 'green' : 'red',
                                                                                                }}
                                                                                                onChange={(event) => handleSwitchChange(event, child, zone.lightInstId)}
                                                                                                inputProps={{
                                                                                                    'aria-label': 'Toggle Switch',
                                                                                                }}
                                                                                            />
                                                                                        </TableCell>
                                                                                        <TableCell align="center" style={{ padding: '4px 16px' }}>{child.itemName}</TableCell>
                                                                                        <TableCell align="center" style={{ padding: '4px 16px' }}>{child.lightNo}</TableCell>
                                                                                        <TableCell align="center" style={{ padding: '4px 16px' }}>{child.walt}</TableCell>
                                                                                        <TableCell align="center" style={{ padding: '4px 16px' }}>
                                                                                            <img
                                                                                                src={child.isOn ? lightOn : lightOff}
                                                                                                alt={child.isOn ? 'Light On' : 'Light Off'}
                                                                                                style={{ width: child.isOn ? 40 : 30, height: child.isOn ? 40 : 30 }}
                                                                                            />
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                ))}
                                                                            </TableBody>
                                                                        </Table>
                                                                    </Box>
                                                                </Collapse>
                                                            </TableCell>
                                                        </TableRow>
                                                    </React.Fragment>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                            </Grid>
                        </Grid>
                    </form>

                </Paper>
            </Card>
            <ToastApp />
        </>
    );
}
